import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetConfigOrdemServicoGeralResponse } from '../../responses/servico/get-config-ordem-servico-geral.response';
import { ConfigOrdemServicoGeralLookupsResponse } from '../../responses/servico/config-ordem-servico-geral-lookups.response';
import { ConfigOrdemServicoGeralRequest } from '../../requests/servico/config-ordem-servico-geral.request';

@Injectable({
  providedIn: 'root',
})
export class ConfigOrdemServicoGeralService extends CommonService {
  private readonly apiUrl: string = environment.urlApiServico + 'ConfigOrdemServicoGeral';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public get(): Observable<GetConfigOrdemServicoGeralResponse> {
    return this.httpClient
      .get<GetConfigOrdemServicoGeralResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getLookups(): Observable<ConfigOrdemServicoGeralLookupsResponse> {
    return this.httpClient
      .get<ConfigOrdemServicoGeralLookupsResponse>(`${this.apiUrl}/lookups`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public update(
    id: number,
    request: ConfigOrdemServicoGeralRequest
  ): Observable<GetConfigOrdemServicoGeralResponse> {
    const url = `${this.apiUrl}/idConfigOrdemServicoGeral/${id}`;
    return this.httpClient
      .put<GetConfigOrdemServicoGeralResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
